import { Link } from "react-router-dom";

const sections = [
  {
    title: "1. Agreement to terms",
    body: [
      'These Terms & Conditions ("Terms") govern your access to and use of ClipTranscript ("we", "us", "our"), including our website, application, and any related services.',
      "By using the Service, you agree to these Terms. If not, you must stop using it.",
      "We may update these Terms at any time. Continued use means acceptance.",
      "The Service is intended for users aged 18 or older.",
    ],
  },
  {
    title: "2. Description of the service",
    body: [
      "ClipTranscript provides tools to extract and process video transcripts, including AI-powered summaries and translations.",
      "The Service is provided for informational purposes only, without guarantees of accuracy.",
    ],
  },
  {
    title: "3. Intellectual property",
    body: [
      "All elements of the Service are owned by or licensed to us.",
      "You are granted a limited, non-exclusive license for personal or internal use.",
      "You may not copy, resell, or reverse engineer the Service.",
    ],
  },
  {
    title: "4. User responsibilities",
    body: [
      "You agree to use the Service lawfully and not abuse or bypass system limitations.",
    ],
  },
  {
    title: "5. Prohibited use",
    body: [
      "You agree not to:",
      "Overload systems",
      "Extract data at scale",
      "Circumvent protections",
      "Build competing products",
    ],
    list: true,
  },
  {
    title: "6. User content",
    body: [
      "You retain ownership of your inputs but grant us the right to process them to operate the Service.",
    ],
  },
  {
    title: "7. AI output",
    body: [
      'AI-generated outputs may contain inaccuracies and are provided "as-is".',
    ],
  },
  {
    title: "8. Third-party services",
    body: [
      "We are not responsible for third-party platforms or content.",
    ],
  },
  {
    title: "9. Privacy",
    body: [
      "We collect limited data (email, usage, technical data) to operate the Service.",
      "We do not sell personal data.",
      "This section is part of these Terms; there is no separate privacy policy on the site.",
    ],
  },
  {
    title: "10. Accounts",
    body: [
      "You are responsible for your account and must provide accurate information.",
    ],
  },
  {
    title: "11. Subscriptions",
    body: [
      "Subscriptions auto-renew unless cancelled.",
      "All payments are non-refundable unless required by law.",
    ],
  },
  {
    title: "12. Service availability",
    body: [
      "The Service may be modified or interrupted at any time.",
    ],
  },
  {
    title: "13. Disclaimer",
    body: [
      'The Service is provided "as-is" without warranties.',
      "ClipTranscript is not affiliated with YouTube or Google.",
    ],
  },
  {
    title: "14. Liability",
    body: [
      "We are not liable for indirect damages. Liability is limited to amounts paid.",
    ],
  },
  {
    title: "15. Termination",
    body: [
      "We may suspend or terminate access at any time.",
    ],
  },
  {
    title: "16. Governing law",
    body: [
      "These Terms are governed by French law.",
    ],
  },
  {
    title: "17. Contact",
    body: [
      <a key="email" href="mailto:contact@cliptranscript.com">
        contact@cliptranscript.com
      </a>,
    ],
  },
];

export default function TermsPage({ isDarkMode }) {
  const bg = isDarkMode ? "#1a1a1a" : "#f9fafb";
  const card = isDarkMode ? "#111827" : "#ffffff";
  const text = isDarkMode ? "#e5e7eb" : "#111827";
  const muted = isDarkMode ? "#9ca3af" : "#6b7280";
  const border = isDarkMode ? "#374151" : "#e5e7eb";
  const link = "#2563eb";

  return (
    <div
      style={{
        minHeight: "calc(100vh - 180px)",
        backgroundColor: bg,
        padding: "clamp(20px, 4vw, 48px) clamp(16px, 4vw, 32px)",
        color: text,
      }}
    >
      <article
        style={{
          maxWidth: "720px",
          margin: "0 auto",
          backgroundColor: card,
          border: `1px solid ${border}`,
          borderRadius: "16px",
          padding: "clamp(24px, 5vw, 40px)",
          boxShadow: isDarkMode
            ? "0 10px 28px rgba(0,0,0,0.35)"
            : "0 10px 28px rgba(17,24,39,0.08)",
        }}
      >
        <p style={{ margin: "0 0 8px 0", fontSize: "14px", color: muted }}>
          <Link to="/" style={{ color: link, textDecoration: "none" }}>
            ← Home
          </Link>
        </p>
        <h1 style={{ margin: "0 0 8px 0", fontSize: "clamp(24px, 5vw, 32px)" }}>
          ClipTranscript — Terms &amp; Conditions
        </h1>
        <p style={{ margin: "0 0 28px 0", color: muted, fontSize: "15px" }}>
          Last updated: May 3, 2026
        </p>
        <p
          style={{
            margin: "0 0 28px 0",
            lineHeight: 1.65,
            color: muted,
            fontSize: "15px",
          }}
        >
          This page combines our Terms &amp; Conditions and our privacy-related
          disclosures in one place for clarity.
        </p>

        {sections.map((sec) => (
          <section key={sec.title} style={{ marginBottom: "28px" }}>
            <h2
              style={{
                margin: "0 0 12px 0",
                fontSize: "clamp(16px, 3vw, 18px)",
                fontWeight: 700,
              }}
            >
              {sec.title}
            </h2>
            {sec.list ? (
              <>
                <p style={{ margin: "0 0 8px 0", lineHeight: 1.65 }}>{sec.body[0]}</p>
                <ul style={{ margin: 0, paddingLeft: "1.25rem", lineHeight: 1.65 }}>
                  {sec.body.slice(1).map((item) => (
                    <li key={item} style={{ marginBottom: "6px" }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              sec.body.map((p, i) => (
                <p key={i} style={{ margin: "0 0 10px 0", lineHeight: 1.65 }}>
                  {p}
                </p>
              ))
            )}
          </section>
        ))}
      </article>
    </div>
  );
}
